<template>
    <div>
        <div class="skill_category_list">
            <p class="skill_state_part">技能分类</p>
            <p class="skill_state_part">得分</p>
            <p class="skill_state_part">Top排名</p>
        </div>
        <v-loader :source="skill_category_info">
            <div class="skill_category_list" v-for="(category_info, index) in skill_category_info" :key="index">
                <p class="skill_state_part">{{ category_info[0] }}</p>
                <p class="skill_state_part">{{ category_info[1] }}</p>
                <p class="skill_state_part">{{ category_info[2] }}</p>
            </div>
        </v-loader>
    </div>
</template>
<script type="text/javascript">

import { mapState, mapActions  } from 'vuex'

export default {
    methods: {
        ...mapActions({
            get_skill_category_info: 'skill/get_skill_category_info',
        })
    },
    computed: {
        ...mapState({
            skill_category_info: state => state.skill.skill_category_info,
        })
    },
    mounted: function () {
        this.get_skill_category_info()
    }
}

</script>
<style type="text/css">
.skill_category_list {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
}
.skill_state_part {
    width: 33%;
    padding: 10px 15px;
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}



</style>
